// extracted by mini-css-extract-plugin
export default {"UnmarkPurchaseModal":"UnmarkPurchaseModal-styles__UnmarkPurchaseModal__J_7TV"};